export default "__VITE_ASSET__ryO7_HiO__"